module.exports = __webpack_public_path__ + "static/media/opensans-light.2e183638.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/opensans-light.woff2
// module id = 293
// module chunks = 0